import { AgFinancingDocumentType } from '@indigo-ag/schema';

export const phase2FileTypes: AgFinancingDocumentType[] = [
  AgFinancingDocumentType.AMENDMENT,
  AgFinancingDocumentType.AMENDMENT_SIGN,
  AgFinancingDocumentType.CAR,
  AgFinancingDocumentType.CERTIFICATE_OF_PLEDGE,
  AgFinancingDocumentType.CESSION_OF_RIGHTS,
  AgFinancingDocumentType.CONSENT_LETTER,
  AgFinancingDocumentType.FIELD_MONITORING_REPORT,
  AgFinancingDocumentType.GUARANTOR,
  AgFinancingDocumentType.INCOME_STATEMENT,
  AgFinancingDocumentType.ISSUER,
  AgFinancingDocumentType.LEASING_CONTRACT,
  AgFinancingDocumentType.MATRICULA,
  AgFinancingDocumentType.CPR,
  AgFinancingDocumentType.OTHER,
  AgFinancingDocumentType.PROMISSORY_NOTE
];
